<template>
  <div class="com-table">
    <div class="table-head row">
      <div
        v-for="item in columns"
        :key="item.prop"
        class="cell"
        :style="{ width: getWidth(item) }"
      >
        {{ item.label }}
      </div>
    </div>
    <div class="table-body">
      <el-scrollbar
        style="width: 100%; height: 100%"
        wrap-style="overflow-x: hidden;"
      >
        <div
          v-for="(row, i) in data"
          :key="i"
          class="table-body-row row"
          @click="$emit('clickRow', row)"
        >
          <div
            v-for="item in columns"
            :key="item.prop"
            class="cell"
            :style="{ width: getWidth(item) }"
          >
            <template v-if="item.slot">
              <slot :name="item.slot" :data="row" :index="i"></slot>
            </template>
            <template v-else>
              {{ row[item.prop] }}
            </template>
          </div>
        </div>
      </el-scrollbar>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      columns: { type: Array, default: () => [] },
      data: { type: Array, default: () => [] },
    },
    data() {
      return {};
    },
    computed: {},
    methods: {
      getWidth(item) {
        const every = Math.round((10 / this.columns.length) * 100) / 10;
        if (!item.width) return `${every}%`;
        if (/^[0-9]*$/.test(item.width)) return `${item.width}px`;
        return item.width;
      },
    },
  };
</script>

<style scoped lang="less">
  @table-head-height: 50px;
  .text-over1 {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .com-table {
    width: 100%;
    height: 100%;

    .table-head {
      height: @table-head-height;
      background: rgba(0, 255, 246, 0.3);
      .cell {
        font-size: 20px;
        font-weight: bold;
      }
    }

    .table-body {
      height: calc(100% - @table-head-height);
      font-size: 16px;
    }

    .table-body-row {
      min-height: 35px;
      background: rgba(0, 255, 246, 0);
      &:nth-child(2n) {
        background: rgba(0, 255, 246, 0.1);
      }
    }

    .row {
      width: 100%;
      display: flex;
      justify-content: space-between;
    }
    .cell {
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
</style>
